module.exports = __webpack_public_path__ + "8b655471ef776b1c7de3639edd3fe936.MP3";